import './BoxSkeleton.css';

export default function BoxSkeleton() {
	return (
		<div className="box-skeleton skeleton">
			<header className="skeleton-element" />
			<h4>
				<span className="skeleton-element"></span>
				<span className="skeleton-element"></span>
				<span className="skeleton-element"></span>
				<span className="skeleton-element"></span>
			</h4>
			<p>
				<span className="skeleton-element"></span>
				<span className="skeleton-element"></span>
				<span className="skeleton-element"></span>
				<span className="skeleton-element"></span>
			</p>
			<p className="impact-text">
				<span className="skeleton-element"></span>
				<span className="skeleton-element"></span>
				<span className="skeleton-element"></span>
			</p>
		</div>
	);
}
